import {Injectable} from "@angular/core";
import {ThemeProxy} from "./theme.proxy";
import cssVars from "css-vars-ponyfill";
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";

/**
 ****************************************************************
 * Service class theme management.
 *
 * Created by Shai Zelman on 06/06/2020.
 ****************************************************************
 */
@Injectable({
	providedIn: "root"
})
export class ThemeService {
	private initialized: boolean = false;

	constructor(private themeProxy: ThemeProxy) {

	}

	public getTheme(): Observable<any> {
		if (this.initialized) {
			return of(null);
		}

		return this.themeProxy.getTheme().pipe(map((variables) => {
			cssVars({
				variables: variables,
				watch: true,
				include: "style"
			});

			this.initialized = true;
		}));
	}
}
